import React, { useState, useEffect } from 'react';

import casualmanImg from '../../../assets/casualman.webp';
import seriousmanImg from '../../../assets/seriousman.webp';
import businessmanImg from '../../../assets/businessman.webp';

import casualmanPng from '../../../assets/casualman.png';
import seriousmanPng from '../../../assets/seriousman.png';
import businessmanPng from '../../../assets/businessman.png';

interface CharacterSelectorSectionProps {
  isLoaded: boolean;
}

const CharacterSelectorSection: React.FC<CharacterSelectorSectionProps> = ({ isLoaded }) => {
  const [selectedCharacter, setSelectedCharacter] = useState(0);
  const [isCharacterRevealed, setIsCharacterRevealed] = useState(false);

  const characterVariations = [
    {
      id: 0,
      name: "Christopher",
      class: "Frontend Developer",
      image: casualmanImg,
      imagePng: casualmanPng,
      stats: [
        { label: "Creativity", value: "+S" },
        { label: "Problem Solving", value: "A" },
        { label: "Code Quality", value: "-A" },
        { label: "Team Work", value: " A" }
      ],
      skills: ["React Mastery", "UI/UX Design", "Animation", "Figma Expert", "API Integration"]
    },
    {
      id: 1,
      name: "Chris",
      class: "The Hobbyist",
      image: seriousmanImg,
      imagePng: seriousmanPng,
      stats: [
        { label: "Drawing", value: "A" },
        { label: "Reading", value: "-A" },
        { label: "Cooking", value: "B" },
        { label: "Anime", value: "-A" }
      ],
      skills: ["Card Collecting", "DIY Crafting", "Trying New Things", "Resourceful", "Good Vibes"]
    },
    {
      id: 2,
      name: "C. Fabian",
      class: "All Business",
      image: businessmanImg,
      imagePng: businessmanPng,
      stats: [
        { label: "Leadership", value: "+B" },
        { label: "Communication", value: "-A" },
        { label: "Networking", value: "B" },
        { label: "Decision Making", value: "S" }
      ],
      skills: ["Crypto Investing", "Negotiation", "Personal Development", "Strategic Planning", "Risk Management"]
    }
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsCharacterRevealed(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`character-select-section ${isLoaded ? 'animate-in' : ''}`}>
      <div className="character-select-header">
        <h2 className="character-select-title">Select Your Developer</h2>
      </div>

      <div className="character-display-area">
        <div className="character-info-left">
          <div className="character-stats-side">
            <div className="stats-title">Stats</div>
            {characterVariations[selectedCharacter].stats.map((stat, index) => (
              <div key={index} className="stat-item-side">
                <div className="stat-label-side">{stat.label}</div>
                <div className="stat-value-side">{stat.value}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="character-center">
          <h3 className="character-name-display">{characterVariations[selectedCharacter].name}</h3>
          <p className="character-class-display">{characterVariations[selectedCharacter].class}</p>
          <picture>
            <source srcSet={characterVariations[selectedCharacter].image} type="image/webp" />
            <img
              src={characterVariations[selectedCharacter].imagePng}
              alt={characterVariations[selectedCharacter].name}
              loading="lazy"
              className={`character-main-image ${isCharacterRevealed ? 'revealed' : ''}`}
            />
          </picture>
        </div>

        <div className="character-info-right">
          <div className="character-skills-side">
            <div className="skills-title-side">Special Abilities</div>
            <div className="skills-list-side">
              {characterVariations[selectedCharacter].skills.map((skill, index) => (
                <span key={index} className="skill-badge-side">{skill}</span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="character-variations">
        {characterVariations.map((character, index) => (
          <picture key={character.id}>
            <source srcSet={character.image} type="image/webp" />
            <img
              src={character.imagePng}
              alt={character.name}
              loading="lazy"
              className={`variation-option ${selectedCharacter === index ? 'selected' : ''}`}
              onClick={() => setSelectedCharacter(index)}
            />
          </picture>
        ))}
      </div>

      <div className="character-select-actions">
        <button className="recruit-button" onClick={() => window.location.href = '/contact'}>
          Recruit Developer
        </button>

        <button className="resume-button" onClick={() => window.location.href = '/resume'}>
          Download Resume
        </button>
      </div>
    </div>
  );
};

export default React.memo(CharacterSelectorSection);
